module.exports = __webpack_public_path__ + "Flag-44.a169172a78870dedb5b599da6640604e.svg";